<template>
  <transition name="fade">
    <div
      v-if="loading && !isShowMap"
      class="loading-page fixed inset-0 flex justify-center items-center h-full w-full bg-black/50 text-center z-50"
    >
      <LoadingIconGrid />
    </div>
  </transition>
</template>

<script setup>
import LoadingIconGrid from '~/assets/svg/spinners/grid.svg?component'

defineProps({
  loading: { type: Boolean, default: false },
})

const { isShowMap } = useSearchForm()
</script>

<style scoped lang="scss">
  .loading-page {
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
</style>
